export enum RoundingMethod {
  Floor = 0,
  Round = 1,
  Ceiling = 2,
  None = 3
}

export const RoundingMethodMapping: Record<RoundingMethod, string> = {
  [RoundingMethod.Floor]: 'Truncate',
  [RoundingMethod.Round]: 'Round',
  [RoundingMethod.Ceiling]: 'Round Up',
  [RoundingMethod.None]: 'No rounding'
};
